@use "ui/styles/colors";
@use "ui/styles/sizes";
@use "ui/styles/fonts";

.errorBody {
  display: flex;
  justify-content: center;
  align-items: center;
  background: colors.$redLightest;
  border-radius: sizes.$s3;
  padding: sizes.$s4;
}

.errorText {
  display: flex;
  color: colors.$redDark;
  gap: sizes.$s4;
  font-weight: fonts.$medium;
}
